import { Alert, AlertIcon, AlertTitle, Button, Flex, FormControl, Grid, Image, Input, Select, Text, useColorMode, useToast, VStack } from '@chakra-ui/react'
import Card from 'components/Card/Card'
import CardBody from 'components/Card/CardBody'
import CardHeader from 'components/Card/CardHeader'
import { useEffect, useState } from 'react'
import { sanitizeField } from 'functions/sanitizeForm'
import { states } from 'enums/states'
import { useSubmitGlucoseRegister } from 'hooks/useGlucoseRegister'
import InputMask from "react-input-mask";

import logoHapvida from "assets/images/logo-hapvida.png"

interface FormField {
    key: string,
    label: string,
    options?: Option[]
}

interface Option {
    label: string
    value: string
}

interface FormData {
    key: string,
    value: string
}

const GlucoseRegister = () => {
    const params = new URLSearchParams(window.location.search);
    const cpf = params.get('cpf') || "";

    const [finished, setFinished] = useState<boolean>(false)

    const { setColorMode } = useColorMode()

    useEffect(() => {
        setColorMode("light");
    }, [])

    const toast = useToast()
    const [submitForm, { loading: loadingSubmit }] = useSubmitGlucoseRegister({
        onSuccess: (data: any) => {
            window.location.replace(`/glicemia-monitoramento?cpf=${sanitizeField(cpf)}`);
        },
        onError: () => {
            toast({
                id: "messageSent",
                title: `Ocorreu um erro ao cadastrar`,
                duration: 4000,
                position: "bottom",
                status: "error"
            })
        }
    });

    const [formData, setFormData] = useState({
        cpf: cpf,
        name: "",
        phone: "",
        registration_number: "",
        state: ""
    });

    const allFieldsFilled = (formData: any) => 
        formData.cpf != "" && formData.cpf != null &&
        formData.name != "" && formData.name != null &&
        formData.phone != "" && formData.phone != null &&
        formData.registration_number != "" && formData.registration_number != null &&
        formData.state != "" && formData.state != null;

    const onSubmit = () => {
        formData.cpf = sanitizeField(formData.cpf);
        formData.phone = sanitizeField(formData.phone);

        if(!allFieldsFilled(formData)) {
            toast({
                id: "messageSent",
                title: "Por favor, preencha todos os campos.",
                duration: 4000,
                position: "bottom",
                status: "warning"
            })

            return;
        }

        const variables = {
            input: {
                ...formData
            }
        }

        submitForm({ variables },);
    }

    return (
        <Flex w="full" minH="100vh" justifyContent="center" alignItems="center">
            <Card maxW="420px" minH="460px">
                <CardHeader minH="80px" justifyContent="center" alignItems="center" mx="auto">
                    <VStack w="full" h="full">
                        <Image src={logoHapvida} maxW="200px" h="auto" />
                        <Text align="center">Monitoramento Glicêmico para Diabetes Gestacional</Text>
                    </VStack>
                </CardHeader>
                <CardBody mt="auto" mb="auto">
                    <Flex flexDirection="column" w="full">
                        {
                            finished ?
                                <Flex w="full" justifyContent="center" alignItems="center">
                                    <Alert
                                        status='success'
                                        variant='subtle'
                                        flexDirection='column'
                                        alignItems='center'
                                        justifyContent='center'
                                        textAlign='center'
                                        height='200px'
                                    >
                                        <AlertIcon boxSize='40px' mr={0} />
                                        <AlertTitle mt={4} mb={1} fontSize='lg'>
                                            Cadastro realizado com sucesso!
                                        </AlertTitle>
                                    </Alert>
                                </Flex>
                                :
                                <>
                                    <Grid
                                        w="full"
                                        templateColumns="repeat(1, 1fr)"
                                        templateRows="repeat(2, 1fr)"
                                        gap="16px"
                                        mb="8"
                                    >
                                        <FormControl>
                                            <Text mb={2} fontWeight="bold" fontSize="md">CPF</Text>
                                            <Input
                                                defaultValue={cpf}
                                                value={formData.cpf}
                                                onChange={({ target }) => setFormData({ ...formData, cpf: target.value })}
                                                as={InputMask}
                                                mask={"999.999.999-99"}
                                                borderRadius="8px"
                                                fontSize="md"
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <Text mb={2} fontWeight="bold" fontSize="md">Nome</Text>
                                            <Input
                                                value={formData.name}
                                                onChange={({ target }) => setFormData({ ...formData, name: target.value })}
                                                borderRadius="8px"
                                                fontSize="md"
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <Text mb={2} fontWeight="bold" fontSize="md">Telefone</Text>
                                            <Input
                                                value={formData.phone}
                                                onChange={({ target }) => setFormData({ ...formData, phone: target.value })}
                                                as={InputMask}
                                                mask={"(99) 999999999"}
                                                borderRadius="8px"
                                                fontSize="md"
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <Text mb={2} fontWeight="bold" fontSize="md">Número da Carteirinha</Text>
                                            <Input
                                                value={formData.registration_number}
                                                onChange={({ target }) => setFormData({ ...formData, registration_number: target.value })}
                                                borderRadius="8px"
                                                fontSize="md"
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <Text mb={2} fontWeight="bold" fontSize="md">Região</Text>
                                            <Select value={formData.state} placeholder="Selecione uma opção..." onChange={({ target }) => setFormData({ ...formData, state: target.value})}>
                                                {
                                                    states?.map(option => <option value={option.value}>{option.label}</option>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Flex w="full" mb="2">
                                        <Button
                                            isLoading={loadingSubmit}
                                            disabled={loadingSubmit}
                                            w="full"
                                            colorScheme="blue"
                                            onClick={onSubmit}
                                        >Cadastrar</Button>
                                    </Flex>
                                </>
                        }
                    </Flex>
                </CardBody>
            </Card>
        </Flex>
    )
}

export default GlucoseRegister